import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { memo, useRef, useContext } from "react";
import { DEFAULT_PORTAL_ROOT_ID } from "./constants.js";
import { PortalProviderContext } from "./contexts.js";
const PortalProvider = memo((props) => {
  const portalRootRef = useRef(null);
  const parentPortalProvider = useContext(PortalProviderContext);
  const isRootProvider = parentPortalProvider === null;
  const id = isRootProvider ? DEFAULT_PORTAL_ROOT_ID : props.id;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(PortalProviderContext.Provider, { value: portalRootRef, children: props.children }),
    /* @__PURE__ */ jsx("div", { ref: portalRootRef, className: props.className, id, style: { display: "contents" } })
  ] });
});
PortalProvider.displayName = "Interface.PortalProvider";
export {
  PortalProvider
};
//# sourceMappingURL=PortalProvider.js.map
